"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStartOfCurrentMonth = void 0;
function getStartOfCurrentMonth() {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth());
}
exports.getStartOfCurrentMonth = getStartOfCurrentMonth;
